import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import BuyerProfilesWrapper from 'agency/digital_renderer/components/BuyerProfilesWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const profileDescriptions = {
  BUILDER_RENOVATOR:
    'Renovators are looking for properties that haven’t completely capitalised on their potential value. With the goal to improve the property in a short timeline and then re-sell it for a profit. A great buyer to have interested in your property they see the potential and final dollar figure they could achieve and won’t get hung up on small imperfections or the current state of the home.',
  DEVELOPER:
    'Developers are often interested in properties located in areas experiencing good growth, that potentially accomodate other zoning applications so they can increase the number of properties in an area and successfully build high-density or high value properties on your land. A great buyer to have interested in your home they will be more focused on achieving a set figure for the home then the actual property itself.',
  DOWNSIZER:
    'Downsizers are often families or couples who no longer have the need for as much space as their current home. They are looking for somewhere smaller with a lower cost of upkeep and potentially lower maintenance fittings and gardens. Your home offers them the lifestyle they’re looking for and with a pending or complete sale of their existing home they’ll be well financed and increase your homes sale price.',
  FAMILY:
    'Families are looking for the right size house, in the right location to allow them to live comfortably, close to schools and shopping districts as well as public transport. They generally have quite well defined requirements and if they fall in love with your home they’ll become highly competitive buyers.',
  FIFO_WORKER:
    'These buyers are looking for a property to lock up and leave. They don’t want to worry about big gardens, and usually prefer extra security.',
  FIRST_HOME_BUYER:
    'In terms of layout and location your home is sure to appeal to first home buyers, looking to get themselves onto the property ladder as soon as possible they are highly motivated and encouraged to purchase with government assistance. Looking for properties with access to business districts they are competitive and know what they are looking for.',
  INTERNATIONAL_BUYER:
    'International buyers are looking for the right property to get their foot in the Australian property market, or increase their portfolio. Often less picky about suburbs and more willing to accomodate features that might turn other buyers off they are looking at more properties in a wider range of areas and will pay top dollar for the right property.',
  INVESTOR:
    'Areas that appeal to families and other outlined buyer profiles often appeal even more so to investors. Looking for properties in up and coming and established neighbourhoods that have the potential for strong rental returns or capital growth they will often be able to spend more, with finance ready than competing buyers and will increase the potential sale price of your home.',
  PROFESSIONAL_COUPLE:
    'Professional couples are looking for properties just like yours. Acceptable travel times to work and the opportunity to grow their family in time makes your property interesting to them. Strong buying power and a desire for the type of features your property offers makes them an excellent buyer to compete for your home.',
  REGIONAL_BUYER:
    'Buyers from out of area, looking to move from regional or rural areas. These buyers are competitive for the right home, happy to modify and work around a properties current features and generally looking for something easier to maintain and close to CBDs.',
}

const findContainer = items => items.find(item => item.item_type === 'container')

const renderProfiles = (profileContainer, buyerProfiles, customProfiles) => buyerProfiles.map(({ key, title }) => {
  const customProfileData = customProfiles[key] || {}

  const profileContext = {
    description: customProfileData.description || profileDescriptions[key],
    title: customProfileData.title || title,
  }

  return (
    <div key={key} style={deviceStyle(profileContainer)}>
      <ElementContainer
        forwardContextToItems={profileContext}
        section={profileContainer}
        renderNested
        render={({ itemComponents }) => itemComponents.map(component => component)}
      />
    </div>
  )
})

const filterBuyerProfiles = (buyerProfiles, filters) => {
  const { limit, offset } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit
    ? buyerProfiles.slice(filterOffset, filterLimit)
    : buyerProfiles.slice(filterOffset)

  return limited
}

const BuyerProfiles = (props) => {
  const {
    items,
    options,
  } = props

  const { customProfiles = {}, limit, offset } = options

  const profileContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaign } = defaultContext

  return (
    <BuyerProfilesWrapper
      campaign={campaign}
      render={({ buyerProfiles }) => {
        const filtered = filterBuyerProfiles(buyerProfiles, { limit, offset })
        if (!filtered.length) return null

        return (
          <AnimationWrapper options={options}>
            <div style={style}>{renderProfiles(profileContainer, filtered, customProfiles)}</div>
          </AnimationWrapper>
        )
      }}
    />
  )
}

BuyerProfiles.propTypes = {
  items: PropTypes.array,
  options: PropTypes.object,
}

BuyerProfiles.defaultProps = {
  options: {},
}

export default BuyerProfiles
